import { AlertCircle } from "lucide-react";

/**
 * Chip list of missing skills, used in RoleResultCard for both the
 * "mandatory to apply" and "important to strengthen" buckets.
 */
export const MissingSkillsList = ({
  skills,
  tone, // "rose" | "amber"
  heading,
  total,
  maxShow,
  testId,
}) => {
  if (!skills?.length) return null;
  const toneClasses =
    tone === "rose"
      ? {
          wrap: "border-rose-200 bg-rose-50",
          title: "text-rose-800",
          chip: "bg-rose-100 text-rose-900",
          more: "text-rose-800",
        }
      : {
          wrap: "border-amber-200 bg-amber-50",
          title: "text-amber-800",
          chip: "bg-amber-100 text-amber-900",
          more: "text-amber-800",
        };

  const visible = typeof maxShow === "number" ? skills.slice(0, maxShow) : skills;
  const remainder = typeof maxShow === "number" ? skills.length - maxShow : 0;

  return (
    <div
      data-testid={testId}
      className={`mt-3 rounded-md border ${toneClasses.wrap} p-4`}
    >
      <div
        className={`flex items-center gap-2 text-sm font-semibold ${toneClasses.title}`}
      >
        <AlertCircle size={16} />
        {heading}
        {typeof total === "number" && ` (${skills.length}/${total})`}
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {visible.map((s) => (
          <span
            key={s}
            className={`inline-flex rounded-full ${toneClasses.chip} text-xs font-medium px-2.5 py-1`}
          >
            {s}
          </span>
        ))}
        {remainder > 0 && (
          <span className={`text-xs ${toneClasses.more} px-2 py-1`}>
            +{remainder} more
          </span>
        )}
      </div>
    </div>
  );
};

export default MissingSkillsList;
